<template>
	<div>
		<component :is="currentComponent"
			:phenotypesInUse="phenotypesInUse"
			:utilsBox="utilsBox"
			:sectionConfigs="sectionConfigs">
		</component>
		<!-- <cfde-eco-system v-if="component='cfdeEcoSystem'"></cfde-eco-system> -->
	</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";

import cfdeEcoSystem from "@/components/researchPortal/customComponents/cfdeEcoSystem.vue";
import cfdeLanding from "@/components/researchPortal/customComponents/cfdeLanding.vue";
import GiantGemPkg from "@/components/researchPortal/customComponents/GiantGemPkg.vue";
import kpVariantSifter from "@/components/researchPortal/customComponents/kpVariantSifter.vue";
import GP2Browser from "@/components/researchPortal/customComponents/GP2Browser.vue";

export default Vue.component("research-section-components", {
	props: ["component", "phenotypesInUse", "utilsBox", "sectionConfigs"],
	components: {
		cfdeEcoSystem,
		cfdeLanding,
		GiantGemPkg,
		kpVariantSifter,
		GP2Browser,
	},
	data() {
		return {
			currentComponent: null,
		};
	},
	modules: {
	},
	mounted: function () {

		switch(this.component) {
			case 'cfdeEcoSystem':
				this.currentComponent = cfdeEcoSystem;
				break;
			case 'cfdeLanding':
				this.currentComponent = cfdeLanding;
				break;
			case 'GiantGemPkg':
				this.currentComponent = GiantGemPkg;
				break;
			case 'kpVariantSifter':
				this.currentComponent = kpVariantSifter;
				break;
			case 'GP2Browser':
				this.currentComponent = GP2Browser;
				break;
		}
	},
	computed: {
		
	},
	watch: {
	},
	methods: {
		
	},
});

$(function () { });
</script>
<style>

</style>
